export default __webpack_public_path__ + "static/media/development.da1252e9.svg";